import styled, { css } from "styled-components";

import {
  BorderWrapper,
  DefaultDeleteTableButton,
  DefaultDeleteTableButtonWrapper,
  DefaultShellWrapper,
} from "@FillInTableContainer/shared/styles/shell.style";

export const ShellWrapper = styled(DefaultShellWrapper)``;
export const ShellBorderWrapper = styled(BorderWrapper)``;

// Asset Transfer 가로 테이블 셀: 헤더와 동일한 고정 폭 사용
export const AssetTransferShellWrapper = styled(DefaultShellWrapper)<{
  $width: string;
}>`
  width: ${({ $width }) => $width};
  min-width: ${({ $width }) => $width};
  max-width: ${({ $width }) => $width};
`;

// Asset Transfer 셀의 평평한 outline 보더 (LA&SC Rights Scope 셀과 동일, 카드 아님)
export const AssetTransferShellBorderWrapper = styled(BorderWrapper)`
  padding: 0;
  height: 100%;
  border-radius: 0;
  background-color: #f0f2f4;
  border: 1px solid #f0f2f4;
  outline: 1px solid #e5e7eb;
  outline-offset: -1px;

  ${({ isFocused }) =>
    isFocused &&
    css`
      border-radius: 0;
      outline: 1px solid var(--Color-Common-Border-Interactive-Primary, #0198e9);
      background: var(--Color-Common-Bg-Interactive-Primary-Subtle, #e6f6ff);
    `}
`;

export const DeleteTableButtonWrapper = styled(
  DefaultDeleteTableButtonWrapper,
)``;
export const DeleteTableButton = styled(DefaultDeleteTableButton)``;

// VF Asset Transfer 의 Territory Normalized(Include/Exclude) 클릭 가능한 셸
export const ClickableShellBorderWrapper = styled.div<{
  $isModified: boolean;
  $isPlaceholder: boolean;
}>`
  display: flex;
  height: 100%;
  background-color: #f0f2f4;
  border: 1px solid #f0f2f4;
  outline: 1px solid #e5e7eb;
  outline-offset: -1px;
  cursor: pointer;

  color: var(--Color-Common-Text-Secondary, #515c6c);
  text-align: left;
  font-family: var(--font-pretendard);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;

  padding: 0.4rem 0.8rem;

  ${({ $isModified }) =>
    !$isModified &&
    css`
      color: #11ac45;
    `}

  ${({ $isPlaceholder }) =>
    $isPlaceholder &&
    css`
      color: var(--Color-Common-Text-Tertiary, #7c899c);
    `}
`;
